import { render, staticRenderFns } from "./CollectionEventDetailsHeader.vue?vue&type=template&id=52d4e334&"
import script from "./CollectionEventDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./CollectionEventDetailsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
